import React from 'react';
import './WorkQueue.scss';
import { Helmet } from 'react-helmet';
import { catchPhrase } from '../../components/config/config';
import ActivityCount from './components/ActivityCount';
import MyFilters from './components/MyFilters';
import WorkQueueFilters from './components/WorkQueueFilters';
import { QueueProvider } from './QueueProvider';
import UnassignedPatientTable from './components/Tables/UnassignedPatientTable';
import { WorkQueueTable } from './components/Tables/WorkQueueTable';
import UnassignedMedicationTable from './components/Tables/UnassignedMedicationTable';
import { useUserContext } from 'App/contexts/UserContext';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import MobileCompletedActivitiesTable from './components/Tables/MobileCompletedActivitiesTable';
import { FILTER_TYPE } from './workQueue.constant';

const propTypes = {};

const defaultProps = {};

const WorkQueue = () => {
    const user = useUserContext();
    const { company_permissions: { MckessonCpsIntegration: isMcKessonEnabled = false } = {} } = user;
    const isPatientMessagingEnabled = useIsPermitted(PERMISSION_TYPES.PATIENT_MESSAGING_CONF);
    const isGenerateMobileLinkEnabled = useIsPermitted(PERMISSION_TYPES.GENERATE_MOBILE_LINK);

    return (
        <>
            <Helmet>
                <title>Work Queue - {catchPhrase}</title>
            </Helmet>

            <div className="work-queue">
                <QueueProvider filterType={FILTER_TYPE.WORK_QUEUE}>
                    <aside>
                        <ActivityCount />
                        <MyFilters />
                        <WorkQueueFilters />
                    </aside>
                    <article>
                        {(isPatientMessagingEnabled || isGenerateMobileLinkEnabled) && (
                            <MobileCompletedActivitiesTable />
                        )}
                        <UnassignedPatientTable />
                        {isMcKessonEnabled && <UnassignedMedicationTable />}
                        <WorkQueueTable />
                    </article>
                </QueueProvider>
            </div>
        </>
    );
};

WorkQueue.propTypes = propTypes;
WorkQueue.defaultProps = defaultProps;

export default WorkQueue;
